import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

export const userSearchesColumns = [
    { field: 'searchDatetime', name: 'Search Date ({tz} time zone)', dataType: 'datetime' },
    {
        field: 'searchTerm',
        name: 'Search Term',
        dataType: 'string',
        styles: { minWidth: '30rem' },
    },
];

const UserSearches = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [...userColumns, ...userSearchesColumns];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.searchDate),
    //     {
    //         count: true,
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Searches',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart
                    data={chartData}
                    chartTitle="User Searches Over Time"
                />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows detailed information about individual search queries
                    performed by users within the application. Each row represents a
                    single search action.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Search Date">
                    When the search was performed by the user.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Search Term">
                    The exact query or keywords entered by the user to search for
                    content or information.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserSearches;
